import { Trans } from '@lingui/react/macro';
import type { PropsWithChildren } from 'react';

import { useIntegrationProviders } from '@/api/integration';
import PageError from '@/components/errors/PageError';
import { PageSpinner } from '@/components/loaders';

const IntegrationsListContent = ({ children }: PropsWithChildren) => {
  const { isLoading, error } = useIntegrationProviders();

  if (error) {
    return (
      <div className="px-6 py-8">
        <PageError
          message={<Trans>An error occurred while loading integrations</Trans>}
          detail={<Trans>Please refresh the page and try again</Trans>}
          headingLevel={2}
        />
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="px-6 py-8">
        <PageSpinner text={<Trans>Loading integrations</Trans>} />
      </div>
    );
  }

  return children;
};

export default IntegrationsListContent;
